import { myContainer } from "@/inversify.config";
import { IEmploymentService } from "@/interfaces/IEmploymentService";
import { TYPES } from "@/types";

// ANSKNI-107/108: data access for the external client (Bolag B) portal.
// The backend (PermissionDecorator + the ExternalViewer grant) is the real
// access gate — every call below is already scoped server-side to the
// "Presenterad för kund" shortlist. Nothing here is a security boundary.
const client = myContainer.get<IEmploymentService>(TYPES.IEmploymentService);

export default {
  state: {
    externalApplicant: null as any,
    externalShortlist: [] as any[],
  },
  getters: {
    externalApplicant: (state: any) => state.externalApplicant,
    externalShortlist: (state: any) => state.externalShortlist,
  },
  mutations: {
    setExternalApplicant: (state: any, v: any) => {
      state.externalApplicant = v;
    },
    setExternalShortlist: (state: any, v: any[]) => {
      state.externalShortlist = v;
    },
  },
  actions: {
    // ANSKNI-107: stripped single-applicant view (form data + CV only).
    async loadExternalApplicant({ commit }: any, id: number) {
      const response: any = await client.getExternalApplicant(id);
      const data = response && response.data !== undefined ? response.data : response;
      commit("setExternalApplicant", data);
      return data;
    },

    // ANSKNI-108: invite Bolag B to a container with scoped ExternalViewer access.
    async inviteExternalClient(
      _ctx: any,
      {
        email,
        containerId,
        expiresAt,
      }: { email: string; containerId: number; expiresAt?: string | null }
    ) {
      const response: any = await client.inviteExternalClient(
        email,
        containerId,
        expiresAt ?? null
      );
      return response && response.data !== undefined ? response.data : response;
    },

    // Composes the shortlist B sees: the agency container's positions and, per
    // position, the applicants the decorator resolves (presented ones only for an
    // ExternalViewer). VERIFY IN DEV: container source + the exact scoped shape
    // returned for an ExternalViewer; adjust if B should not read containerId from
    // localStorage. Kept defensive so it renders whatever the API returns.
    async loadExternalShortlist({ commit }: any) {
      let containerId = 0;
      try {
        containerId = Number(localStorage.getItem("containerId")) || 0;
      } catch {
        containerId = 0;
      }

      const result: any[] = [];
      if (containerId) {
        const posResp: any = await (client.Container as any).getPositions(
          containerId
        );
        const positions: any[] = Array.isArray(posResp)
          ? posResp
          : posResp?.data ?? [];

        for (const position of positions) {
          const pid = position?.id ?? position?.positionId;
          if (pid == null) continue;
          let applicants: any[] = [];
          try {
            const appResp: any = await (
              client.JobPosition as any
            ).getApplicantsByPosition(pid);
            applicants = Array.isArray(appResp)
              ? appResp
              : appResp?.data ?? [];
          } catch {
            applicants = [];
          }
          result.push({ position, applicants });
        }
      }
      commit("setExternalShortlist", result);
      return result;
    },
  },
};
